import { useContext } from "react";
import { ContextAdmin } from "../../DashboardUsers";
import { updateUserData, deleteUser } from "../../../api/admin/adminServices";
export default function BtnActionUpdateDeleteUser(param) {
  const {
    dataUsersJson,
    getUserDataToTable,
    setMessageModal,
    setShowModalMessage,
    setIconToShow,
    listNamePlansToShow,
    functionStorage,
    setShowModalConfirm,
  } = useContext(ContextAdmin);
  let canUpdateUser = true;

  let dataUsers = JSON.parse(dataUsersJson.current);
  let indexRow = param["node"]["sourceRowIndex"];
  let userDataOnTable = param["data"];
  dataUsers[indexRow]["data_expiracao"] = new Date(
    dataUsers[indexRow]["data_expiracao"]
  );
  if (
    dataUsers[indexRow]["data_expiracao"].getTime() !==
    userDataOnTable["data_expiracao"].getTime()
  ) {
    canUpdateUser = false;
  } else if (
    dataUsers[indexRow]["tipo_de_plano"] !== userDataOnTable["tipo_de_plano"]
  ) {
    canUpdateUser = false;
  } else if (dataUsers[indexRow]["username"] !== userDataOnTable["username"]) {
    canUpdateUser = false;
  }

  function updateUser(userReply) {
    
    if (userReply) {
      let new_data_expiracao = userDataOnTable["data_expiracao"];
      let new_plan_type = userDataOnTable["tipo_de_plano"];
      let new_username = userDataOnTable["username"];

      let userId = dataUsers[indexRow]["id"];

      let list_data_to_send = {
        id: userId,
        date_expiration: new_data_expiracao,
        plan_name:
          listNamePlansToShow.current[new_plan_type] !== undefined
            ? listNamePlansToShow.current[new_plan_type][0]
            : "gratuito",
        user_type:
          new_username === "" || new_username === undefined
            ? "user"
            : new_username,
      };

      setIconToShow("");
      setMessageModal("Aguarde enquanto atualizamos os dados do usuário.");
      setShowModalMessage(true);

      updateUserData(list_data_to_send).then((data) => {
        if (data["statusHttp"] !== 200) {
          setIconToShow("error");
          setMessageModal(data["message"]);
        } else {
          setMessageModal("Dados do usuário atualizados com sucesso!");
          getUserDataToTable(true);
        }
      });
    }
  }

  

  function DeleteaUser(userReply) {
    
    if (userReply) {
      let userId = dataUsers[indexRow]["id"];
      let list_data_to_send = {
        id: userId,
      };

      setIconToShow("");
      setMessageModal("Aguarde um momento, estamos removendo o usuário.");
      setShowModalMessage(true);

      deleteUser(list_data_to_send).then((data) => {
        if (data["statusHttp"] !== 200) {
          setIconToShow("error");
          setMessageModal(data["message"]);
        } else {
          setMessageModal("Remoção concluída: usuário removido com sucesso!");
          getUserDataToTable(true);
        }
      });
    }
  }

  function startUpdate(){
    functionStorage.current = updateUser;
    setShowModalConfirm(true);
    setMessageModal("Tem certeza de que deseja atualizar esta conta?");
  }

  function startDelete(){
    functionStorage.current = DeleteaUser;
    setShowModalConfirm(true);
    setMessageModal("Tem certeza mesmo que deseja excluir esta conta? Essa ação não pode ser desfeita.");
  }

  return (
    <div className="d-flex justify-content-around">
      <button
        className="btn btn-success"
        disabled={canUpdateUser}
        onClick={startUpdate}
      >
        U
      </button>
      <button className="btn btn-danger" onClick={startDelete}>
        D
      </button>
    </div>
  );
}
